import styles from './Bar.module.css';
import React from 'react';
export var Bar = function (props) {
    return React.createElement("div", { className: styles.bar, style: props.styles });
};
